//封装axios
import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../router';
// import { Notify } from 'vant'
import store from '../store/index';
import VueLocalStorage from 'vue-localstorage'
import { Message } from 'element-ui'
// Vue.use(Notify)
import ApiSetting from '@/request/api/setting'
Vue.use(VueLocalStorage)

const toLogin = function () {
  window.console.log("toLogin")
  // store.commit('setRedirect', router.currentRoute.fullPath)
  Vue.localStorage.set('redirect', router.currentRoute.fullPath)
  // router.replace({path: '/auth/wechat'})
  router.replace({path: '/account/login/'})
}
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 400:
      Message.error({
        message: '请求参数不正确'
      })
      break;
    // 401: 未登录状态，跳转登录页
    case 401:
      // Message.error({
      //   message: '需要登录'
      // })
      if (store.state.authProcessing == false) {
        store.commit('authProcessing', true)
        toLogin()
      }
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      Message.error({
        message: '操作被禁止'
      })
      break;
    // 404请求不存在
    case 404:
      Message.error({
        message: '资源没有找到'
      })
      break;
    case 500:
      Message.error({
        message: '服务器出错'
      })
      break;
    case 504:
      Message.error({
        message: '服务器连接失败'
      })
      break;
    default:
      Message.error({
        message: `出现错误：${other}`
      })
      break;
  }}


// 创建axios实例
var instance = axios.create({ timeout: 1000 * 12});

// post 请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // const token = store.state.auth.token
    // const expire = store.state.auth.expire
    // if (token && expire) {
    //   // window.console.log("有token和过期时间")
    //   // window.console.log(token)
    //   // window.console.log(expire)
    //   const now = new Date().getTime()
    //   // window.console.log(`token: ${token}`)
    //   // window.console.log(`timestamp: ${expire}`)
    //   // window.console.log(`now: ${now}`)
    //   let processing = store.state.authProcessing
    //   if (now >= expire && processing == false) {
    //     window.console.log("token已过期，需要刷新")
    //     store.commit('authProcessing', true)
    //     axios.post(
    //       '/api-token-refresh/',
    //       qs.stringify({'token': token})
    //     ).then((response) => {
    //       window.console.log('刷新token成功')
    //       window.console.log(response)
    //       store.commit(
    //         'tokenRefreshed',
    //         {
    //           token: response.data.token,
    //           expire: new Date().getTime() + 50 * 60 * 1000, // 50分钟后过期（实际过期时间60分钟，10分钟缓冲）
    //           processing: false
    //         })
    //       config.headers.Authorization = 'JWT ' + token
    //       store.commit('authProcessing', false)
    //     }).catch (error => {
    //       window.console.log('刷新token失败')
    //       window.console.log(error)
    //       store.commit('tokenClear')
    //       store.commit('authProcessing', false)
    //     })
    //   } else { // 有 token 且未过期
    //     // window.console.log("token未过期")
    //     config.headers.Authorization = 'JWT ' + token
    //   }
    // }
    let token = store.state.token
    if (token == null) {
      token = Vue.localStorage.get('token', null)
      store.commit('setToken', token)
    }
    if (token) {
      let refreshTime = store.state.refreshTime || Vue.localStorage.get('refreshTime')
      if (refreshTime) {
        store.commit('setRefreshTime', refreshTime)
        if (new Date().getTime() >= store.state.refreshTime) {
          let tokenRefreshUrl = ApiSetting.baseUrl + '/api-token-auth/'
          axios.post(
            tokenRefreshUrl, qs.stringify({'token': token})
          ).then((response) => {
            window.console.log('刷新token成功')
            window.console.log(response)
            store.commit('setToken', response.token)
            store.commit(
              'setRefreshTime', new Date().getTime() + 50 * 60 * 1000)
            config.headers.Authorization = 'JWT ' + token
          }).catch (error => {
            window.console.log("更新Token失败")
            window.console.log(error)
          })
        }
      }
      config.headers.Authorization = 'JWT ' + token
    } else {
      window.console.log("没有找到token")
      toLogin()
    }
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // https://www.django-rest-framework.org/api-guide/status-codes/#successful-2xx
    let codes = [200, 201, 202, 203, 204, 205, 206, 207, 208, 226]
    if (codes.indexOf(response.status) != -1) {
      if(typeof response.data != 'undefined'){
        return Promise.resolve(response);
      }else{
        return Promise.reject(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {

    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);

    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      //store.commit('changeNetwork', false);
      //toSignin();
      //vueobj.$message.error({showClose: true, message: "与服务器连接失败！", duration: 3000});

      var originalRequest = error.config;
      if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){
        // originalRequest._retry = true
        // return axios.request(originalRequest);
        // vueobj.$message.error({showClose: true, message: "请求超时，请稍后重试！", duration: 3000});
        // Notify({ type: 'danger', message: '请求超时，请稍后再试' })
      //   this.$notify.error({
      //   title: '发送请求出错',
      //   message: '请求超时，请稍后再试'
      // });
      Message.error({
        message: '请求超时，请稍后再试'
      })
        return Promise.reject(response);
      }else{
        // Notify({ type: 'danger', message: '连接错误' })
      //   this.$notify.error({
      //   title: '发送请求出错',
      //   message: '连接错误'
      // });
      Message.error({
        message: '连接错误'
      })
      }
    }
  }
);

export default instance;
